// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Uf","play":"Vf"};